import React from 'react';
import { Routes, Route } from 'react-router-dom';
import WeekPage from './WeekPage';

/** Pages under /casa/semana. */
const WeekRoutes: React.FC = () => (
  <Routes>
    <Route index element={<WeekPage />} />
  </Routes>
);

export default WeekRoutes;
